import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./lib/i18n";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { installErrorReporting } from "./lib/errorReporting";
import "./styles.css";

installErrorReporting();

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found.");

createRoot(root).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
